import React from 'react';
import { PanelHeader } from '@apply/components';

export const PanelHeaderDemo: React.FC<{}> = ({}) => {
    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Panel Header</li>
            <PanelHeader>Draws Mobile Header Panel</PanelHeader>
        </div>
    );
};
